"use strict";

exports.__esModule = true;
exports.TimeSeriesLineChart = void 0;
var _react = _interopRequireDefault(require("react"));
var _recharts = require("recharts");
var _timeSeriesAxis = require("../Axes/XAxis/timeSeriesAxis");
var _yAxis = require("../Axes/YAxis/yAxis");
var _TooltipContent = require("../Tooltip/TooltipContent");
var _constants = require("../constants");
var _styledComponents = require("styled-components");
var _legendStyle = require("../legendStyle");
var _modernChartLayout = require("../modernChartLayout");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var TimeSeriesLineChart = exports.TimeSeriesLineChart = function TimeSeriesLineChart(props) {
  var width = props.width,
    height = props.height,
    _props$showChartToolt = props.showChartTooltip,
    showChartTooltip = _props$showChartToolt === void 0 ? true : _props$showChartToolt,
    _props$showLegend = props.showLegend,
    showLegend = _props$showLegend === void 0 ? true : _props$showLegend,
    _props$showGrid = props.showGrid,
    showGrid = _props$showGrid === void 0 ? true : _props$showGrid,
    _props$chartCurve = props.chartCurve,
    chartCurve = _props$chartCurve === void 0 ? _constants.STEP_AFTER : _props$chartCurve,
    _props$data = props.data,
    timeSeriesData = _props$data === void 0 ? [] : _props$data,
    _props$tooltipProps = props.tooltipProps,
    tooltipProps = _props$tooltipProps === void 0 ? {} : _props$tooltipProps,
    _props$legendProps = props.legendProps,
    legendProps = _props$legendProps === void 0 ? {} : _props$legendProps,
    _props$xAxisProps = props.xAxisProps,
    xAxisProps = _props$xAxisProps === void 0 ? {} : _props$xAxisProps,
    _props$yAxisProps = props.yAxisProps,
    yAxisProps = _props$yAxisProps === void 0 ? {} : _props$yAxisProps,
    _props$showReferenceL = props.showReferenceLine,
    showReferenceLine = _props$showReferenceL === void 0 ? false : _props$showReferenceL,
    referenceLineValue = props.referenceLineValue;
  var theme = _react["default"].useContext(_styledComponents.ThemeContext);
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "line-chart-test-id"
  }, /*#__PURE__*/_react["default"].createElement(_recharts.LineChart, _extends({
    width: width,
    height: height
  }, (0, _modernChartLayout.modernChartProps)(theme)), showGrid && (theme.uiModern ? /*#__PURE__*/_react["default"].createElement(_recharts.CartesianGrid, {
    vertical: false,
    stroke: theme.ChartGridColor
  }) : /*#__PURE__*/_react["default"].createElement(_recharts.CartesianGrid, {
    strokeDasharray: "3 3"
  })), (0, _yAxis.yAxis)(Object.assign({}, yAxisProps, {
    theme: theme
  })), (0, _timeSeriesAxis.timeSeriesAxis)(Object.assign({}, xAxisProps, {
    theme: theme
  })), showChartTooltip && /*#__PURE__*/_react["default"].createElement(_recharts.Tooltip, {
    cursor: theme.uiModern ? {
      stroke: theme.ToolTipHandleColor,
      strokeWidth: 1
    } : true,
    content: /*#__PURE__*/_react["default"].createElement(_TooltipContent.TooltipContent, {
      xDataKey: "key",
      chartType: _constants.LINE_CHART,
      xValueFormatter: tooltipProps.xValueFormatter,
      yValueFormatter: tooltipProps.yValueFormatter
    })
  }), timeSeriesData.map(function (itemData) {
    return /*#__PURE__*/_react["default"].createElement(_recharts.Line, {
      className: "line-" + itemData.name,
      dataKey: "value",
      data: itemData.data,
      dot: false,
      type: chartCurve,
      name: itemData.name,
      key: itemData.name,
      stroke: itemData.color,
      strokeWidth: theme.uiModern ? 1.4 : 1
    });
  }), showReferenceLine ? /*#__PURE__*/_react["default"].createElement(_recharts.Line, {
    className: "reference-line",
    dataKey: "value",
    data: [{
      key: timeSeriesData[0].data[0].key < xAxisProps.domain[0] ? timeSeriesData[0].data[0].key : xAxisProps.domain[0],
      value: referenceLineValue
    }, {
      key: xAxisProps.domain[1],
      value: referenceLineValue
    }],
    dot: false,
    type: chartCurve,
    name: "reference-line",
    key: "reference-line",
    stroke: "#000000",
    strokeDasharray: "5 10",
    strokeWidth: 2
  }) : null, showLegend && /*#__PURE__*/_react["default"].createElement(_recharts.Legend, _extends({}, (0, _legendStyle.legendStyle)(theme, {
    iconType: "plainline",
    iconSize: 14
  }), legendProps, {
    wrapperStyle: {
      fontSize: (0, _legendStyle.legendFontSize)(theme)
    }
  }))));
};